import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import "./index.css";
import "./styles/white-label-restricar.css";
import AppRouter from "./routes/AppRouter";
import { applyWhiteLabelTheme } from "./utils/whiteLabel";
import { PermissionProvider } from "./contexts/ApplicationContext";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import MapsProvider from "./components/common/query/MapsProvider";

// Antes do render para o tema já valer na primeira pintura.
applyWhiteLabelTheme();

const removeLoadingSpinner = () => {
  const loadingContainer = document.getElementById("loading-container");
  if (loadingContainer) {
    loadingContainer.style.display = "none";
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      staleTime: Infinity,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <MapsProvider>
      <PermissionProvider>
        <AppRouter />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
        />
      </PermissionProvider>
    </MapsProvider>
  </QueryClientProvider>,
);

window.addEventListener("load", removeLoadingSpinner);
